var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload_cls"},[_c('el-upload',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploadflag),expression:"uploadflag"}],staticClass:"upload-demo",attrs:{"action":"","before-upload":_vm.beforeUpload,"multiple":"","limit":_vm.limit}},[_c('el-button',{staticClass:"h-btn h-bBtn h-bgwhite"},[_vm._v("上传头像")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }